import { call, take, race, delay } from 'redux-saga/effects';

export function decodeUrlParameters(input) {
  const tokens = input.split('&');
  const result = {};
  tokens.forEach(token => {
    const keyValuePair = token.split('=');
    const key = decodeURIComponent(keyValuePair[0]);
    if (keyValuePair.length > 1) {
      // eslint-disable-next-line prefer-destructuring
      result[key] = decodeURIComponent(keyValuePair[1]);
    } else {
      result[key] = true;
    }
  });
  return result;
}

export function buildUrl(originUrl, filters, locale) {
  const pos = originUrl.indexOf('?');
  let baseUrl;
  const baseParams = { _locale: locale };
  if (pos > -1) {
    baseUrl = originUrl.substr(0, pos);
    if (pos + 1 < originUrl.length) {
      const baseSearch = decodeUrlParameters(originUrl.substr(pos + 1));
      // eslint-disable-next-line no-return-assign
      Object.keys(baseSearch).forEach(key => (baseParams[key] = baseSearch[key]));
    }
  } else {
    baseUrl = originUrl;
  }
  const search = serializeQuery({ ...baseParams, ...filters });
  if (search.length > 0) {
    return baseUrl + '?' + search;
  }
  return baseUrl;
}

function serializeQuery(params, prefix) {
  const query = Object.keys(params)
    .filter(key => params[key] !== undefined && params[key] !== null)
    .map(key => {
      const value = params[key];

      // eslint-disable-next-line no-param-reassign
      if (params.constructor === Array) key = `${prefix}[]`;
      // eslint-disable-next-line no-param-reassign
      else if (params.constructor === Object) key = prefix ? `${prefix}[${key}]` : key;

      if (typeof value === 'object') return serializeQuery(value, key);
      return `${key}=${encodeURIComponent(value)}`;
    });

  // eslint-disable-next-line prefer-spread
  return [].concat.apply([], query).join('&');
}

export function createLoadingReducer(statePropName) {
  return (state, { loading }) => ({ ...state, [statePropName]: loading });
}

export function createErrorReducer(statePropName) {
  return (state, { error }) => ({
    ...state,
    [statePropName]: [...state[statePropName], error],
  });
}

export function createErrorRemoveReducer(statePropName) {
  return (state, { index }) => ({
    ...state,
    [statePropName]: state[statePropName].filter((error, errorIndex) => index !== errorIndex),
  });
}

export function createErrorClearReducer(statePropName) {
  return state => ({
    ...state,
    [statePropName]: [],
  });
}

export function decorateEntity(entity, descriptor) {
  return descriptor.__decorator(entity);
}

export function addSubreducers(reducerMap) {
  return (state, action) => {
    return Object.keys(reducerMap).reduce((state, namespace) => {
      const reducerFn = reducerMap[namespace];
      const newState = reducerFn(state[namespace], action);
      return newState !== state[namespace] ? { ...state, [namespace]: newState } : state;
    }, state);
  };
}
